<template>
  <div>
    <el-radio-group v-model="checkedOption">
      <el-radio v-for="(item, index) in getOptions" :key="index" :label="item.id" @change="update($event)">
        <template>
          <el-image :src="getImg(item)" :z-index="5000" :preview-src-list="[getImg(item)]" />
          <span class="text" v-html="item.content.richText || item.content.text"></span>
        </template>
      </el-radio>
    </el-radio-group>
  </div>
</template>

<script>
import { getImg, saveArr } from '../public/index.js'
import mixins from '../mixins'
import { itemInitOptions } from '../config/config.js'

export default {
  name: 'ImageChoice',
  mixins: [mixins],
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 需要更新的 数组
    updateArr: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      radio: ''
    }
  },
  methods: {
    getImg,
    update(val) {
      this.rowData.items[0].optionId = val
      this.rowData.items[0].value = this.getOptions.find(itm => {
        return itm.id === val
      }).content.text // text 不是 richText
      this.saveArr()
    },
    // saveArr() {
    //   const existIdx = this.updateArr.findIndex((item) => {
    //     return item.questonId === this.rowData.questonId
    //   })
    //   if(existIdx === -1) { //添加
    //     this.updateArr.push(this.rowData)
    //   }
    // },
    saveArr
  },
  computed: {
    getOptions() {
      return this.rowData.questionDetails.issue.items
    },
    checkedOption: {
      get() {
        if (!this.rowData.items.length) {
          this.rowData.items.push(Object.assign({}, itemInitOptions))
        }
        return this.rowData.items[0].optionId
      },
      set(v) {
        this.rowData.items[0].optionId = v
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep.el-radio {
  border: 1px solid #ccc;
  border-radius: 2px;
  overflow: hidden;
  margin-bottom: 10px;
}
::v-deep.el-radio__label {
  display: flex;
  flex-direction: column;
  padding: 0;
  .el-image {
    margin-bottom: 8px;
    img {
      width: 70px;
    }
  }
  .text {
    padding-left: 18px;
    max-width: 55px;
    word-break: normal;
    display: block;
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow: hidden;
    margin-bottom: 5px;
  }
}
::v-deep.el-radio__input {
  position: absolute;
  left: 0;
  bottom: 3px;
}
</style>
